import React from "react";

const MieszkaniecInformacje = props => {

    const { mieszkaniec } = props;

    return (
        <div>
            <ul className="lista mieszkaniecDane">
                <li>
                    <div>Imię i nazwisko</div>
                    <div>{mieszkaniec?.imie_nazwisko || 'Wczytuję...'}</div>
                </li>
                <li>
                    <div>Telefon</div>
                    <div>{mieszkaniec?.telefon || 'Wczytuję...'}</div>
                </li>
                <li>
                    <div>E-mail</div>
                    <div>{mieszkaniec?.email || 'Wczytuję...'}</div>
                </li>
            </ul>
        </div>
    )
}

export default MieszkaniecInformacje;